import OneEmployeePage from './OneEmployeePage';

export default OneEmployeePage;
